import { render, staticRenderFns } from "./DemandDetail.vue?vue&type=template&id=27b4405c"
import script from "./DemandDetail.vue?vue&type=script&lang=js"
export * from "./DemandDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports